module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAJCAYAAADkZNYtAAAAAXNSR0IArs4c6QAAALdJREFUKFOFkDEOgkAURGeyxMLWE1jauRsIpY0eQCux91Raq5UXkMaSABtvoBewNbFYvoEEQgjqL+dPZl6G6Dlr7cwYc+2+2BayLBuKyJ5kBOAAYOv7/qv2NOYkScZKqTOAaf0UkVtRFKswDO+lVpnTNF2QPAIYdatF5AkgCoLgwjzPJ2UCgEEff5VIvgHoKtlaO3fOnUj2Jiul1saY+C+z53lLrfWjYa7ryzUA7ABsfq7R5v228wd6tUiag89ChgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/listicon.png
// module id = J2ME
// module chunks = 20